module.exports = __webpack_public_path__ + "img/post3.0fd4b4fd.png";